<svelte:options
  customElement={{ tag: "kalender-vershandling", shadow: "none" }}
/>

<script lang="ts">
  import { onMount } from "svelte";

  interface Bibelvers {
    jahr_monat: string; // Format: "YYYY-MM"
    vers: string;
  }

  let ready: boolean = $state(false);
  // Array der 12 Monate (von 1 bis 12)
  const monate: string[] = [
    "Januar",
    "Februar",
    "März",
    "April",
    "Mai",
    "Juni",
    "Juli",
    "August",
    "September",
    "Oktober",
    "November",
    "Dezember"
  ];
  let bibelverse: Bibelvers[] = $state([]);
  let bibelverseReverse: Bibelvers[] = $derived([...bibelverse].reverse());
  let buttonText: string = $state("Alle speichern");
  let nochNichtGespeichert: boolean = $state(false);

  onMount(async () => {
    bibelverse = await GetBibelverse();
    ready = true;
  });

  async function GetBibelverse(): Promise<Bibelvers[]> {
    let response = await fetch(
      `handleVersForMonth.php?task=loadAlleMonatsVerse`
    );
    if (!response.ok) {
      alert("Fehler beim Laden der Bibelverse");
      return [];
    }
    return await response.json();
  }

  async function SaveBibelverse() {
    console.log("Bibelverse speichern...", bibelverse);
    let response = await fetch("handleVersForMonth.php", {
      method: "POST",
      body: JSON.stringify({
        task: "saveAlleMonatsVerse",
        verse: bibelverse
      })
    });
    if (!response.ok) {
      alert("Fehler beim Speichern der Bibelverse");
      return;
    }
  }
</script>

{#if ready == true}
  <div class="druckDiv well well-sm">
    <legend
      >Bibelverse{@html nochNichtGespeichert
        ? " <span style='color: red;'>(Änderungen noch nicht gespeichert)</span>"
        : ""}</legend
    >
    <button
      class="btn"
      class:btn-primary={buttonText === "Alle speichern"}
      class:btn-warning={buttonText !== "Alle speichern"}
      style="margin-bottom: 15px;"
      onclick={() => {
        buttonText = "Wird gespeichert...";
        SaveBibelverse().finally(() => {
          buttonText = "Alle speichern";
          nochNichtGespeichert = false;
        });
      }}
    >
      {buttonText}
    </button>
    <div id="monatsVerse">
      {#each bibelverseReverse as { jahr_monat, vers }, i}
        <div class="input-group">
          <span class="input-group-addon">
            {monate[parseInt(jahr_monat.split("-")[1]) - 1]}
            {jahr_monat.split("-")[0]}
          </span>
          <input
            bind:value={bibelverseReverse[i].vers}
            type="text"
            class="monatsversInput form-control"
            data-monat={jahr_monat.split("-")[1]}
            data-jahr={jahr_monat.split("-")[0]}
            placeholder="Vers unter {monate[
              parseInt(jahr_monat.split('-')[1]) - 1
            ]}-Kalender"
            id="textUnterKalender{i}"
            onkeydown={() => {
              nochNichtGespeichert = true;
            }}
          />
        </div>
        <!-- TODO: Unterscheidung nach Rechten, falls nicht, nur anzeigen -->
      {/each}
    </div>
  </div>
{/if}
